module.exports = __webpack_public_path__ + "img/honors_2025.2b5d99c4.png";